
<mat-card style="box-shadow:none;    padding: 0px !important;" [class.mat-elevation-z1]="'true'">
    <mat-card-header>
        <span mat-card-avatar>
        <mat-icon>edit</mat-icon>
        </span>
        <mat-card-title>Edit Contact Person</mat-card-title>

    </mat-card-header>
    <mat-divider></mat-divider>
    <div style="text-align: -webkit-right !important; padding-right: 15px; padding-top: 15px;">
        <mat-form-field style="width: 60%;     display: inline;">
            <mat-label>Search Email</mat-label>
            <input matInput [formControl]="searchControl" placeholder="search">
        </mat-form-field>
    </div>
    <mat-dialog-content style="overflow-y: auto; max-height: 400px;">
        <div style="display: flex; justify-content: space-between; gap: 20px;">
          <!-- Table for All Emails -->
          <div style="flex: 1;">
            <h3>All Emails</h3>
            <table mat-table [dataSource]="dataSource" style="width: 100%;">
              <!-- Email Column -->
              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef>Email Address</th>
                <td mat-cell *matCellDef="let element">
                  <ng-container *ngIf="!element.isEditing; else editTemplate">
                    <span 
                      (click)="enableEdit(element)" 
                      style="cursor: pointer;" 
                      [class.red-font]="element.isEditing">
                      {{ element.email }}
                    </span>
                  </ng-container>
                  <ng-template #editTemplate>
                    <input
                      matInput
                      [(ngModel)]="element.email"
                      (blur)="saveEmail(element)"
                      (keydown.enter)="saveEmail(element)"
                      placeholder="Enter email"
                      style="color: red;" />
                  </ng-template>
                </td>
              </ng-container>
            
              <!-- Checkbox Column -->
              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef style="text-align: center;">
                  <mat-checkbox
                    (change)="toggleSelectAll($event)"
                    [checked]="isAllSelected()"
                    [indeterminate]="isSomeSelected()">
                  </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let element" style="text-align: center;">
                  <mat-checkbox
                    (change)="toggleSelection(element)"
                    [checked]="isSelected(element)">
                  </mat-checkbox>
                  <button
                    type="button"
                    mat-icon-button
                    style="color:#bf1e2e"
                    (click)="deleteEmail(element)">
                    <mat-icon class="sidenav-icon">delete</mat-icon>
                  </button>
                </td>
              </ng-container>
            
              <tr mat-header-row *matHeaderRowDef="['email', 'select']"></tr>
              <tr mat-row *matRowDef="let row; columns: ['email', 'select']"></tr>
            </table>
            
            <mat-paginator [pageSizeOptions]="[10, 25, 50]" showFirstLastButtons></mat-paginator>
          </div>

          <!-- Table for Selected Emails -->
          <div style="flex: 1;">
            <h3>Selected Emails</h3>
            <table mat-table [dataSource]="selectedEmails" style="width: 100%;">
              <!-- Email Column -->
              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef>Email Address</th>
                <td mat-cell *matCellDef="let element">{{ element.email }}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="['email']"></tr>
              <tr mat-row *matRowDef="let row; columns: ['email']"></tr>
            </table>
          </div>
        </div>
      </mat-dialog-content>

<mat-dialog-actions>
<button style="  font-size: 10px;
margin-right: 5px;
scale: 1;
background: #bf1e2e;
color: white;
border-radius: 0px;
text-shadow: none;
box-shadow: none;
flex: 1 1 100%;
box-sizing: border-box;
max-width: 50px;
cursor: pointer;
transition: background-color 0.3s;
box-shadow: none !important;" mat-raised-button (click)="onCancelClick()">Cancel</button>

<button style="  font-size: 10px;
margin-right: 5px;
scale: 1;
background: #bf1e2e;
color: white;
border-radius: 0px;
text-shadow: none;
box-shadow: none;
flex: 1 1 100%;
box-sizing: border-box;
max-width: 105px;
cursor: pointer;
transition: background-color 0.3s;
box-shadow: none !important;" mat-raised-button (click)="onAddClick()">Add New Email</button>
<button style="  font-size: 10px;
margin-right: 5px;
scale: 1;
background: #16447f;
color: white;
border-radius: 0px;
text-shadow: none;
box-shadow: none;
flex: 1 1 100%;
box-sizing: border-box;
max-width: 105px;
cursor: pointer;
transition: background-color 0.3s;
box-shadow: none !important;" mat-raised-button (click)="assign()">Assign</button>
</mat-dialog-actions>
</mat-card>

